<script setup>
import { ref } from 'vue';
defineProps({
  message: {
    required: true,
    type: Object, // {heading: string, content: string[]}
  },
  invertX: {
    required: false,
    type: Boolean,
    default: false,
  },
  invertY: {
    required: false,
    type: Boolean,
    default: false,
  },
});

const innerRef = ref();
defineExpose({ innerRef });
</script>
<template>
  <div ref="innerRef" class="absolute z-10 text-block-wrapper">
    <div class="relative h-40 w-max overflow-hidden" :class="[invertX ? 'pl-10 md:pr-4 md:pl-4' : 'pl-10']">
      <div
        class="absolute inset-0 bg-[url('@/assets/images/traffic-cloud.svg')] bg-no-repeat bg-contain -z-10"
        :class="[
          `${invertX && 'md:scale-x-[-1]'}`,
          `${invertY && 'scale-y-[-1]'}`,
        ]"
        role="img"
        aria-label="ský með texta"
      />
      <div class="pl-3 pr-3 pb-8 w-75">
        <div class="text-xl text-red font-bold pt-3 pb-2">
          {{ message.heading }}
        </div>
        <ul>
          <li
            v-for="(li, idx) in message.content"
            :key="idx"
            class="list-disc text-[11px] leading-[1.4]"
          >
            {{ li }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
